import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        width: "100%",
        borderRadius: 16,
        position: "relative"
      },
      "& .MuiDialogContent-root": {
        marginTop: 8,
        padding: "32px 24px 0 24px",
        textAlign: "center"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "24px 24px 32px",
        columnGap: 16,
        justifyContent: "center"
      }
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 4,
      "& p": {
        margin: 0
      }
    },
    titleHeader: {
      fontSize: "20px",
      color: "#000000",
      fontWeight: 700,
      marginTop: "16px !important"
    },
    btnAction: {
      height: 48,
      background: "#009FB8 !important",
      width: "100%",
      "&:hover": {
        background: "#007B8A !important"
      },
      "&:focus": {
        border: "none",
        outline: "none"
      },
      "&:active": {
        border: "none",
        outline: "none"
      }
    },
    textBtn: {
      color: "#ffffff",
      fontSize: "18px",
      fontWeight: 400
    }
  }),
  { name: "DialogAddMatSuccess" }
);

export default useStyles;
